import React from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Pie } from "react-chartjs-2";
import ConfigData from "../config/config.json";

const webserver = ConfigData.WEBSERVER;

ChartJS.register(ArcElement, Tooltip, Legend);
ChartJS.register({
  id: "customSpacingLegend",
  beforeInit(chart) {
    const originalFit = chart.legend.fit;

    chart.legend.fit = function fit() {
      originalFit.bind(chart.legend)();
      this.height += 15;
    };
  },
});

export default function App(props) {
  const [value, setValue] = React.useState(null);

  React.useEffect(() => {
    fetch(
      webserver.protocol +
        "://" +
        webserver.host +
        ":" +
        webserver.port +
        "/stats/getStatsOverTimePeriod?fromDate=" +
        props.fromDate +
        "&tillDate=" +
        props.tillDate,
      { method: "GET", credentials: "include" }
    )
      .then((response) => {
        if (response.status !== 200) {
          throw new Error("Error: " + response.status);
        }
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        setValue(data);
      })
      .catch((error) => {
        //TODO global error cannot load user table
      });
  }, [props.tillDate, props.fromDate]);

  const data = {
    labels: [
      "Bestanden",
      "Folgeprüfung bestanden",
      "Durchgefallen",
      "Mehrfach durchgefallen",
    ],
    datasets: [
      {
        label: "# of Votes",
        data: [
          value !== null ? value.passedCount : 0,
          value !== null ? value.passedAfterFailureCount : 0,
          value !== null ? value.failedCount : 0,
          value !== null ? value.multiplefailuresCount : 0,
        ],
        backgroundColor: [
          "rgba(46, 153, 51, 0.8)",
          "rgba(0, 216, 11, 0.8)",
          "rgba(254, 118, 0, 0.8)",
          "rgba(210, 0, 14, 0.8)",
        ],
        borderColor: ["#ffffff", "#ffffff", "#ffffff", "#ffffff"],
        borderWidth: 2,
        hoverOffset: 30,
      },
    ],
  };

  const options = {
    maintainAspectRatio: true,
    responsive: true,
    aspectRatio: 1.5,
    plugins: {
      legend: {
        labels: {
          boxWidth: 20,
        },
      },
    },
    layout: {
      padding: 20,
    },
  };

  return <Pie data={data} options={options} />;
}
